import {useQuery} from '@tanstack/react-query';

import {getTokenizationConfig} from '../../transport/paymentCardApiV2';

import type {TokenizationConfigResponse} from './types';

export const TOKENIZATION_CONFIG_QUERY_KEY = ['tokenizationConfig'] as const;

/**
 * Fetch Till SDK tokenization config for card capture.
 *
 * @param enabled - Whether to fetch (typically tied to modal visibility)
 * @returns Till SDK config with integration_key and environment
 */
export const useTokenizationConfig = (enabled: boolean = true) => {
  return useQuery<TokenizationConfigResponse>({
    queryKey: TOKENIZATION_CONFIG_QUERY_KEY,
    queryFn: getTokenizationConfig,
    enabled,
    // Don't cache - always fetch fresh config when modal opens
    staleTime: 0,
    gcTime: 0,
  });
};
